import { html } from 'lit';
const MoveToRightDuotone =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.75 4c.966 0 1.75.784 1.75 1.75V8.5a.75.75 0 0 1-1.5 0V5.75a.25.25 0 0 0-.25-.25h-3a.25.25 0 0 0-.25.25v13c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25V16a.75.75 0 0 1 1.5 0v2.75a1.75 1.75 0 0 1-1.75 1.75h-3A1.75 1.75 0 0 1 4 18.75v-13C4 4.784 4.784 4 5.75 4zm7.25.75a.75.75 0 0 1 .75-.75h1c.966 0 1.75.784 1.75 1.75v13a1.75 1.75 0 0 1-1.75 1.75h-1a.75.75 0 0 1 0-1.5h1a.25.25 0 0 0 .25-.25v-13a.25.25 0 0 0-.25-.25h-1a.75.75 0 0 1-.75-.75m-2.397 4.924a.75.75 0 0 0-.096 1.056l.642.77H10.75a.75.75 0 0 0 0 1.5h3.399l-.642.77a.75.75 0 1 0 1.152.96l1.667-2a.75.75 0 0 0 0-.96l-1.667-2a.75.75 0 0 0-1.056-.096" clip-rule="evenodd"/>
  </svg>
`;
export default MoveToRightDuotone;
